import React from 'react';
import ReleasePlanSection from "./ReleasePlanSection";

/**
 * Release plan component.
 * @param props
 * @returns {*}
 * @constructor
 */
const ReleasePlan = props => {
    const { groups, lang } = props;
    return (
        <React.Fragment>
            {groups && groups.map((quizData, index) => {
                return (
                    <ReleasePlanSection key={index} index={index}
                                        quizGroup={quizData}
                                        lang={lang}/>
                );
            })}
        </React.Fragment>
    );
};

export default ReleasePlan;
